import React, { useContext, useState } from "react";
import "./Login_Signup.css";
import { Form } from "react-bootstrap";
import Blue_White_Gradient_Btn from "../common_components/common_btn/blue_white_gradient_btn/Blue_White_Gradient_Btn";
import { useNavigate, Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faBackward,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
import PasswordChecklist from "react-password-checklist";
import { Login, Register } from "../../utils/apis/login/Login";
import Cookies from "js-cookie";
import { Context } from "../../utils/context";
import classNames from "classnames";
import { RegxExpression } from "../../utils/common";
import Successfull_Modal from "../common_components/common_modal/successfull_modal/Successfull_Modal";
import Success_Lottie from "../animation/success_lottie/Success_Lottie";
import Disclaimer_Modal from "../common_components/common_modal/disclaimer_modal/Disclaimer_Modal";

const Login_Signup = () => {
  const [activeTab, setActiveTab] = useState("signin");

  const { signin, setSignin, getuserData } = useContext(Context);
  const [verifyError, setVerifyError] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [modalShowPolicy, setModalShowPolicy] = useState(false);
  const [modalLoginShow, setModalLoginShow] = useState(false);

  const [showForgetPassword, setShowForgetPassword] = useState(false);

  const navigate = useNavigate("");

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  console.log(errors, "errors");

  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEyeSlash);
  const [iconTwo, setIconTwo] = useState(faEyeSlash);

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    }
  };

  const onSubmit = async (data) => {
    const finalData = new FormData();
    finalData.append("first_name", data?.first_name);
    finalData.append("last_name", data?.last_name);
    finalData.append("refer_code", data?.refer_code);
    finalData.append("country_id", data?.country_id?.value);
    finalData.append("email", data?.email);
    finalData.append("contact_no", data?.contact_no);
    finalData.append("password", data?.password);
    finalData.append("not_us_client", data?.not_us_client);
    finalData.append(
      "accept_terms_and_condition",
      data?.accept_terms_and_condition
    );
    if (password === passwordAgain) {
      const res = await Register(finalData);

      if (res?.success) {
        await Cookies.set("stoxwave_security", res?.data?.token);
        setSignin(true);
        getuserData(res?.data?.id);
        setVerifyError("");

        setModalShow(true);
        setTimeout(() => {
          setModalShow(false);
          navigate("/trade");
          window.location.reload();
        }, 2000);
      } else {
        if (res?.errors?.both) {
          setError("email", { message: res?.message?.both });
          setError("contact_no", { message: "" });
        }
        if (res?.errors?.email) {
          setError("email", { message: res?.errors?.email });
        }
        if (res?.errors?.contact_no) {
          setError("contact_no", { message: res?.errors?.contact_no });
        }
        if (res?.errors?.refer_code) {
          setError("refer_code", { message: res?.errors?.refer_code });
        }
        setVerifyError(res.code);
      }
    } else {
      setError("re_password", { message: "Password Does not match" });
    }
  };

  const onSubmitLogin = async (data) => {
    const res = await Login(data);

    if (res?.success) {
      await Cookies.set("stoxwave_security", res?.data?.token);
      setSignin(true);
      getuserData(res?.data?.id);
      setModalLoginShow(true);

      setTimeout(() => {
        setModalLoginShow(false);
        navigate("/trade");
      }, 2000);
    } else {
      if (res?.errors?.password) {
        setError("password", { message: res.errors.password });
      }
      if (res?.errors?.email) {
        setError("email", { message: res.errors.email });
      }
    }
  };

  return (
    <section className="Login_Signup">
      <div className="container">
        <div className="tab_container">
          {activeTab === "signin" && (
            <div className="login_tab_div">
              <div className="back_icon_holder">
                <FontAwesomeIcon
                  icon={faArrowLeft}
                  className="icon"
                  onClick={() => {
                    navigate("/trade");
                  }}
                />
              </div>

              <p className="heading_title">Welcome to StockWave</p>
              <p className="heading_subtitle">
                Your Gateway to Smarter Investing
              </p>

              <div className="tabs_btn_holder">
                <div className="sign_btn_div">
                  <button
                    className={`White_Btn ${
                      activeTab === "signin" ? "active" : ""
                    }`}
                    type="button"
                    onClick={() => setActiveTab("signin")}
                  >
                    LogIn
                  </button>
                </div>

                <div className="sign_btn_div">
                  <button
                    className={`White_Btn ${
                      activeTab === "signup" ? "active" : ""
                    }`}
                    type="button"
                    onClick={() => setActiveTab("signup")}
                  >
                    Create Account
                  </button>
                </div>
              </div>

              <Form className="login_form">
                <div className="outer_form_div">
                  <Form.Group className="custom_form_group" controlId="">
                    <Form.Label className="black_input_label">
                      Your Email Address
                    </Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      {...register("email", {
                        required: "Email is required",
                        pattern: {
                          value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                          message: "Invalid email address",
                        },
                      })}
                      className={classNames("", {
                        "is-invalid": errors?.email,
                      })}
                    />
                  </Form.Group>
                  {errors?.email && (
                    <sup className="text-danger">{errors?.email?.message}</sup>
                  )}
                </div>

                <div className="outer_form_div">
                  <Form.Group className="custom_form_group password_holder">
                    <Form.Label className="black_input_label">
                      Password
                    </Form.Label>
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      name="password"
                      {...register("password", {
                        required: "Password is required",
                      })}
                      className={classNames("", {
                        "is-invalid": errors?.password,
                        "is-valid": getValues("password"),
                      })}
                    />{" "}
                    <div className="eye-icc">
                      <FontAwesomeIcon
                        icon={iconOne}
                        className="eye-icon"
                        onClick={() => togglePasswordVisibility("password")}
                      />
                    </div>
                  </Form.Group>
                  {errors?.password && (
                    <sup className="text-danger">
                      {errors?.password?.message}
                    </sup>
                  )}
                  <p
                    className="forgot_text"
                    onClick={() => navigate("/verify-email")}
                  >
                    Forgot password?
                  </p>
                </div>

                <Form.Check
                  type="checkbox"
                  id="termsCheckbox"
                  {...register("terms", {
                    required: "You must accept the Investment Policy",
                  })}
                  label={
                    <span
                      className="forgot_text"
                      onClick={(e) => {
                        e.stopPropagation();
                        setModalShowPolicy(true); // or your modal state handler
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      Investment Policy
                    </span>
                  }
                />
                {errors?.terms && (
                  <sup className="text-danger">{errors.terms.message}</sup>
                )}

                <div className="form_footer">
                  <div className="continue_btn">
                    <Blue_White_Gradient_Btn
                      btn_name="Continue"
                      onClick={handleSubmit(onSubmitLogin)}
                    />
                  </div>

                  {/* <div className='or_div'>
                    <p className='or_text'>Or Sign In With</p>
                  </div>

                  <div className='img_holder'>
                    <img src='/assets/images/images.jpg' className='google_img' />
                  </div> */}
                </div>
              </Form>
            </div>
          )}

          {activeTab === "signup" && (
            <div className="login_tab_div sign_up_div">
              <div className="back_icon_holder">
                <FontAwesomeIcon
                  icon={faArrowLeft}
                  className="icon"
                  onClick={() => {
                    navigate("/trade");
                  }}
                />
              </div>

              <p className="heading_title">Create Your Account</p>
              <p className="heading_subtitle">Catch the Next Big Wave</p>

              <div className="tabs_btn_holder">
                <div className="sign_btn_div">
                  <button
                    className={`White_Btn ${
                      activeTab === "signin" ? "active" : ""
                    }`}
                    type="button"
                    onClick={() => setActiveTab("signin")}
                  >
                    Sign In
                  </button>
                </div>

                <div className="sign_btn_div">
                  <button
                    className={`White_Btn ${
                      activeTab === "signup" ? "active" : ""
                    }`}
                    type="button"
                    onClick={() => setActiveTab("signup")}
                  >
                    Create Account
                  </button>
                </div>
              </div>

              <Form className="login_form">
                <div className="row">
                  <div className="col-sm-6">
                    <div className="outer_form_div">
                      <Form.Group className="custom_form_group" controlId="">
                        <Form.Label className="black_input_label">
                          {" "}
                          First Name
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="first_name"
                          // placeholder="Enter First Name"
                          {...register("first_name", {
                            required: "First Name is required",
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.first_name,
                            // "is-valid": getValues("first_name"),
                          })}
                          onKeyDown={(event) => {
                            if (!RegxExpression.name.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                        />{" "}
                      </Form.Group>
                      {errors?.first_name && (
                        <sup className="text-danger">
                          {errors?.first_name?.message}
                        </sup>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="outer_form_div">
                      <Form.Group className="custom_form_group" controlId="">
                        <Form.Label className="black_input_label">
                          {" "}
                          Last Name
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="last_name"
                          {...register("last_name", {
                            required: "Last Name is required",
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.last_name,
                            // "is-valid": getValues("last_name"),
                          })}
                          onKeyDown={(event) => {
                            if (!RegxExpression.name.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                        />{" "}
                      </Form.Group>
                      {errors?.last_name && (
                        <sup className="text-danger">
                          {errors?.last_name?.message}
                        </sup>
                      )}
                    </div>
                  </div>
                </div>

                <div className="outer_form_div">
                  <Form.Group className="custom_form_group" controlId="">
                    <Form.Label className="black_input_label">
                      {" "}
                      Country / Region of Residence
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="country"
                      {...register("country", {
                        required: "Country is required",
                      })}
                      className={classNames("", {
                        "is-invalid": errors?.country,
                        // "is-valid": getValues("country"),
                      })}
                      onKeyDown={(event) => {
                        if (!RegxExpression.name.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />{" "}
                  </Form.Group>
                  {errors?.country && (
                    <sup className="text-danger">
                      {errors?.country?.message}
                    </sup>
                  )}
                </div>

                <div className="outer_form_div">
                  <Form.Group className="custom_form_group" controlId="">
                    <Form.Label className="black_input_label">Email</Form.Label>
                    <Form.Control
                      type="text"
                      name="email"
                      {...register("email", {
                        required: "Email is required",
                        pattern: {
                          value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                          message: "Invalid email format",
                        },
                      })}
                      className={classNames("", {
                        "is-invalid": errors?.email,
                      })}
                    />
                  </Form.Group>
                  {errors?.email && (
                    <sup className="text-danger">{errors?.email?.message}</sup>
                  )}
                </div>

                <div className="outer_form_div">
                  <Form.Group className="custom_form_group" controlId="">
                    <Form.Label className="black_input_label">
                      Contact No
                    </Form.Label>
                    <Form.Control
                      type="number"
                      name="contact_no"
                      {...register("contact_no", {
                        required: "Contact No is required",
                        pattern: {
                          value: /^[0-9]{10}$/,
                          message: "Contact No must be exactly 10 digits",
                        },
                      })}
                      className={classNames("", {
                        "is-invalid": errors?.contact_no,
                      })}
                    />
                  </Form.Group>
                  {errors?.contact_no && (
                    <sup className="text-danger">
                      {errors?.contact_no?.message}
                    </sup>
                  )}
                </div>

                <div className="outer_form_div">
                  <Form.Group className="custom_form_group" controlId="">
                    <Form.Label className="black_input_label">
                      {" "}
                      Refer Code
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="refer_code"
                      {...register("refer_code", {
                        // required: "Refer Code is required",
                      })}
                      className={classNames("", {
                        "is-invalid": errors?.refer_code,
                        // "is-valid": getValues("refer_code"),
                      })}
                      onKeyDown={(event) => {
                        if (!RegxExpression.name.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />{" "}
                  </Form.Group>
                  {errors?.refer_code && (
                    <sup className="text-danger">
                      {errors?.refer_code?.message}
                    </sup>
                  )}
                </div>

                <div className="outer_form_div">
                  <Form.Group
                    className="custom_form_group password_holder"
                    controlId=""
                  >
                    <Form.Label className="black_input_label">
                      {" "}
                      Password
                    </Form.Label>
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      name="password"
                      {...register("password", {
                        required: "Password is required",
                        minLength: {
                          value: 8,
                          message:
                            "Password must be at least 8 characters long",
                        },
                        pattern: {
                          value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                          message:
                            "Password must contain at least one uppercase letter, one lowercase letter, and one number",
                        },
                      })}
                      onChange={(e) => {
                        setPassword(e.target.value);
                        clearErrors("password");
                      }}
                    />

                    <div className="eye-icc">
                      <FontAwesomeIcon
                        icon={iconOne}
                        className="icon"
                        onClick={() => togglePasswordVisibility("password")}
                      />
                    </div>
                  </Form.Group>
                  {errors?.password && (
                    <sup className="text-danger">
                      {errors?.password?.message}
                    </sup>
                  )}
                </div>

                <div className="outer_form_div">
                  <Form.Group
                    className="custom_form_group password_holder"
                    controlId=""
                  >
                    <Form.Label className="black_input_label">
                      Confirm Password
                    </Form.Label>
                    <Form.Control
                      type={showPasswordOne ? "text" : "password"}
                      name="re_password"
                      {...register("re_password", {
                        required: "Re-Password is required",
                      })}
                      onChange={(e) => {
                        setPasswordAgain(e.target.value);
                        clearErrors("re_password");
                      }}
                    />

                    <div className="eye-icc">
                      <FontAwesomeIcon
                        icon={iconTwo}
                        className="icon"
                        onClick={() =>
                          togglePasswordVisibility("reenterPassword")
                        }
                      />
                    </div>
                  </Form.Group>
                  {errors?.re_password && (
                    <sup className="text-danger">
                      {errors?.re_password?.message}
                    </sup>
                  )}{" "}
                </div>

                {password && (
                  <PasswordChecklist
                    className="password_checklist"
                    rules={[
                      "minLength",
                      "specialChar",
                      "number",
                      "capital",
                      "match",
                    ]}
                    minLength={8}
                    value={password}
                    valueAgain={passwordAgain}
                    onChange={(isValid) => {}}
                    style={{
                      fontSize: "10px",
                      padding: "4px",
                      margin: "0",
                    }}
                  />
                )}

                <div className="declare_div">
                  <Form.Check
                    type="checkbox"
                    label="I Declare and confirm that I am not a citizen or resident of the US for tax purpose."
                    {...register("not_us_client", {
                      required: "You must confirm this declaration.",
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.not_us_client,
                    })}
                  />
                  {errors?.not_us_client && (
                    <sup className="text-danger">
                      {errors?.not_us_client?.message}
                    </sup>
                  )}
                </div>

                <div>
                  <Form.Check
                    type="checkbox"
                    id="termsCheckbox"
                    {...register("terms", {
                      required: "You must accept Investment Policy",
                    })}
                    label={
                      <span
                        className="forgot_text"
                        onClick={(e) => {
                          e.stopPropagation();
                          setModalShowPolicy(true); // or your modal state handler
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        Investment Policy
                      </span>
                    }
                  />
                  {errors?.terms && (
                    <sup className="text-danger">{errors.terms.message}</sup>
                  )}
                </div>

                <div className="declare_div">
                  <Form.Check
                    type="checkbox"
                    {...register("accept_terms_and_condition", {
                      required: "You must accept all terms and conditions.",
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.accept_terms_and_condition,
                    })}
                    label="I accept all terms and conditions."
                  />
                  {errors?.accept_terms_and_condition && (
                    <sup className="text-danger">
                      {errors?.accept_terms_and_condition?.message}
                    </sup>
                  )}
                </div>

                <div className="form_footer">
                  <div className="continue_btn">
                    <Blue_White_Gradient_Btn
                      btn_name="Continue"
                      onClick={handleSubmit(onSubmit)}
                    />
                  </div>
                </div>
              </Form>
            </div>
          )}

          <Successfull_Modal
            show={modalShow}
            message="Account Created Successfully"
            onHide={() => setModalShow(false)}
            lottie={<Success_Lottie />}
          />

          <Successfull_Modal
            show={modalLoginShow}
            message="Login Successfully"
            onHide={() => setModalLoginShow(false)}
            lottie={<Success_Lottie />}
          />

          <Disclaimer_Modal
            show={modalShowPolicy}
            onHide={() => setModalShowPolicy(false)}
          />
        </div>
      </div>
    </section>
  );
};

export default Login_Signup;
